import AssetProcessingSkeleton, { type AssetSkeletonColumn } from '@/matter-asset-common/asset/AssetProcessingSkeleton'

/**
 * Skeleton table shown while the first billing summary build is in flight. Thin wrapper
 * over the shared AssetProcessingSkeleton that supplies the billing-summary column set.
 */

// Mirrors the live MedSummaryEntriesTable columns (rowNumber + data columns) with their
// fixed widths, so columns don't shift when data lands.
const SKELETON_COLUMNS: AssetSkeletonColumn[] = [
  { width: 35, label: '' },
  { width: 134, label: 'Date' },
  { width: 274, label: 'Facility' },
  { width: 100, label: 'Type' },
  { width: 126, label: 'Amount' },
  { width: 140, label: 'Procedure Code' },
  { width: 395, label: 'Source File' },
]

export default function MedSummaryAssetProcessingSkeleton() {
  return <AssetProcessingSkeleton columns={SKELETON_COLUMNS} />
}
